"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoveTo = function MoveTo(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    version: "1.1",
    className: className,
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6H20C21.11 6 22 6.89 22 8V18C22 19.11 21.11 20 20 20H4C2.89 20 2 19.11 2 18L2.01 6C2.01 4.89 2.89 4 4 4H10L12 6ZM4 6V18H20V8H11.17L9.17 6H4Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13L13 8.5V11H9V15H13V17.5L19 13Z",
    fill: "#212121"
  }));
};

var _default = MoveTo;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9Nb3ZlVG8udHN4Il0sIm5hbWVzIjpbIk1vdmVUbyIsImNsYXNzTmFtZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRUEsSUFBTUEsTUFBd0MsR0FBRyxTQUEzQ0EsTUFBMkM7QUFBQSxNQUFHQyxTQUFILFFBQUdBLFNBQUg7QUFBQSxzQkFDL0M7QUFDRSxJQUFBLEtBQUssRUFBQyxNQURSO0FBRUUsSUFBQSxNQUFNLEVBQUMsTUFGVDtBQUdFLElBQUEsT0FBTyxFQUFDLFdBSFY7QUFJRSxJQUFBLElBQUksRUFBQyxNQUpQO0FBS0UsSUFBQSxPQUFPLEVBQUMsS0FMVjtBQU1FLElBQUEsU0FBUyxFQUFFQSxTQU5iO0FBT0UsSUFBQSxLQUFLLEVBQUMsNkJBUFI7QUFRRSxJQUFBLFVBQVUsRUFBQztBQVJiLGtCQVVFO0FBQ0UsSUFBQSxRQUFRLEVBQUMsU0FEWDtBQUVFLElBQUEsUUFBUSxFQUFDLFNBRlg7QUFHRSxJQUFBLENBQUMsRUFBQztBQUhKLElBVkYsZUFlRTtBQUFNLElBQUEsUUFBUSxFQUFDLFNBQWY7QUFBeUIsSUFBQSxRQUFRLEVBQUMsU0FBbEM7QUFBNEMsSUFBQSxDQUFDLEVBQUMsc0NBQTlDO0FBQXFGLElBQUEsSUFBSSxFQUFDO0FBQTFGLElBZkYsQ0FEK0M7QUFBQSxDQUFqRDs7ZUFvQmVELE0iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5jb25zdCBNb3ZlVG86IFJlYWN0LkZDPHsgY2xhc3NOYW1lPzogc3RyaW5nIH0+ID0gKHsgY2xhc3NOYW1lIH0pID0+IChcbiAgPHN2Z1xuICAgIHdpZHRoPVwiMjRweFwiXG4gICAgaGVpZ2h0PVwiMjRweFwiXG4gICAgdmlld0JveD1cIjAgMCAyNCAyNFwiXG4gICAgZmlsbD1cIm5vbmVcIlxuICAgIHZlcnNpb249XCIxLjFcIlxuICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgIHhtbG5zPVwiaHR0cHM6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCJcbiAgICB4bWxuc1hsaW5rPVwiaHR0cHM6Ly93d3cudzMub3JnLzE5OTkveGxpbmtcIlxuICA+XG4gICAgPHBhdGhcbiAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICBjbGlwUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgZD1cIk0xMiA2SDIwQzIxLjExIDYgMjIgNi44OSAyMiA4VjE4QzIyIDE5LjExIDIxLjExIDIwIDIwIDIwSDRDMi44OSAyMCAyIDE5LjExIDIgMThMMi4wMSA2QzIuMDEgNC44OSAyLjg5IDQgNCA0SDEwTDEyIDZaTTQgNlYxOEgyMFY4SDExLjE3TDkuMTcgNkg0WlwiXG4gICAgLz5cbiAgICA8cGF0aCBmaWxsUnVsZT1cImV2ZW5vZGRcIiBjbGlwUnVsZT1cImV2ZW5vZGRcIiBkPVwiTTE5IDEzTDEzIDguNVYxMUg5VjE1SDEzVjE3LjVMMTkgMTNaXCIgZmlsbD1cIiMyMTIxMjFcIiAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IE1vdmVUbztcbiJdfQ==